import { motion } from "framer-motion";
import { ABOUT, PDF_BG } from "../data/content";
import SectionBg from "./SectionBg";

const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: (i = 0) => ({
        opacity: 1,
        y: 0,
        transition: { delay: i * 0.08, duration: 0.8, ease: [0.16, 1, 0.3, 1] },
    }),
};

export default function About() {
    return (
        <section
            id="about"
            className="relative py-24 md:py-40 overflow-hidden"
            data-testid="about-section"
        >
            <SectionBg src={PDF_BG.about} opacity={0.6} />
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 relative">
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                    variants={fadeUp}
                    className="text-xs uppercase tracking-[0.3em] text-[#FF6B35] font-mono mb-6"
                >
                    {ABOUT.eyebrow}
                </motion.div>

                <div className="grid grid-cols-12 gap-6 md:gap-12 items-start">
                    <motion.h2
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, margin: "-100px" }}
                        custom={1}
                        variants={fadeUp}
                        className="col-span-12 lg:col-span-8 min-w-0 max-w-full font-display font-bold text-[1.78rem] leading-[1.12] tracking-normal break-words [overflow-wrap:anywhere] sm:text-5xl sm:leading-[1.05] sm:tracking-tight lg:text-6xl"
                    >
                        {ABOUT.title.split("advertising").map((part, i) =>
                            i === 0 ? (
                                <span key={i}>
                                    {part}
                                    <span className="gradient-text">advertising</span>
                                </span>
                            ) : (
                                <span key={i}>{part}</span>
                            ),
                        )}
                    </motion.h2>

                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, margin: "-100px" }}
                        custom={2}
                        variants={fadeUp}
                        className="col-span-12 lg:col-span-4 min-w-0 max-w-full space-y-5 text-zinc-300 leading-relaxed text-sm [overflow-wrap:anywhere] sm:text-base md:text-lg"
                    >
                        {ABOUT.body.map((p, i) => (
                            <p key={i}>{p}</p>
                        ))}
                    </motion.div>
                </div>

                {/* Stats */}
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-px mt-16 md:mt-20 bg-white/10 rounded-3xl overflow-hidden border border-white/10">
                    {ABOUT.stats.map((s, i) => (
                        <motion.div
                            key={s.label}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: i * 0.1, duration: 0.7 }}
                            whileHover={{ backgroundColor: "rgba(255,107,53,0.08)" }}
                            className="bg-[#0a0a0a] p-6 sm:p-8 md:p-10 group cursor-default"
                            data-testid={`stat-${i}`}
                        >
                            <div className="font-display text-3xl sm:text-4xl md:text-5xl font-black text-white group-hover:text-[#FF6B35] transition-colors">
                                {s.value}
                            </div>
                            <div className="text-xs uppercase tracking-[0.25em] text-zinc-500 mt-3 font-mono">
                                {s.label}
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
